





































































































































import Vue from "vue";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import InfoCard from "@/components/SpaceOverview/InfoCard.vue";
import InfoLine from "@/components/SpaceOverview/InfoLine.vue";
import { format } from "@/utils/memoryFormat";
interface LoadItem {
  name: string;
  val: number;
}
export default Vue.extend({
  name: "SpaceOverview",
  components: { InfoCard, InfoLine },
  data() {
    return {
      usedMemoryValue: "",
      maxMemoryValue: "",
      loadItems: [] as Array<LoadItem>
    };
  },
  watch: {
    $route(to, from) {
      // 切换空间
      if (to.name == "TanOverview" && from.name == "TanOverview") {
        this.clear();
        this.getBasic();
        this.getResource();
        this.getChartData();
        this.getLoad().then(() => {
          this.setLoadItems();
        });
      }
    },
    "resource.usedMemory": {
      immediate: true,
      handler(usedMemory) {
        this.usedMemoryValue = format(usedMemory);
      }
    },
    "resource.maxMemory": {
      immediate: true,
      handler(maxMemory) {
        this.maxMemoryValue = format(maxMemory);
      }
    }
  },
  mounted() {
    this.getBasic();
    this.getResource();
    this.getLoad().then(() => {
      this.setLoadItems();
    });
  },
  beforeDestroy() {
    this.clear();
  },
  computed: {
    ...mapGetters("LoginInfo", ["tenant"]),
    ...mapState("SpaceOverview", [
      "basicLoading",
      "basic",
      "resourceLoading",
      "resource",
      "memoryLoading",
      "memory",
      "cpuLoading",
      "cpu",
      "load"
    ])
  },
  methods: {
    ...mapActions("SpaceOverview", [
      "getBasic",
      "getResource",
      "getLoad",
      "getMemaryUse",
      "getCpuUse"
    ]),
    ...mapMutations("SpaceOverview", { clear: "CLEAR" }),
    getChartData() {
      (this.$refs.cpu as any).getData();
      (this.$refs.memory as any).getData();
    },
    setLoadItems() {
      Object.keys(this.load).map((key: string) => {
        switch (key) {
          case "statefulSetCount":
            this.$set(this.loadItems, 0, {
              name: "有状态负载",
              val: this.load[key],
              icon: "icon-fuben"
            });
            break;
          case "deploymentCount":
            this.$set(this.loadItems, 1, {
              name: "无状态负载",
              val: this.load[key],
              icon: "icon-bushu"
            });
            break;
          case "serviceCount":
            this.$set(this.loadItems, 2, {
              name: "服务",
              val: this.load[key],
              icon: "icon-fuwuqi"
            });
            break;
          case "ingressCount":
            this.$set(this.loadItems, 3, {
              name: "路由",
              val: this.load[key],
              icon: "icon-luyouguanli"
            });
            break;
          case "podCount":
            this.$set(this.loadItems, 4, {
              name: "容器组",
              val: this.load[key],
              icon: "icon-col_containers"
            });
            break;
          case "jobCount":
            this.$set(this.loadItems, 5, {
              name: "任务",
              val: this.load[key],
              icon: "icon-vedioAI"
            });
            break;
          case "cronJobCount":
            this.$set(this.loadItems, 6, {
              name: "定时任务",
              val: this.load[key],
              icon: "icon-dingshirenwu"
            });
            break;
        }
      });
    },
    getPersent(v1: number, v2: number) {
      if (!v1 || !v2) return 0;
      const persent = (v1 / v2) * 100;
      return persent > 100 ? 100 : parseFloat(persent.toFixed(2));
    }
  }
});
